// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g-button {
  height: 100%;
  border-radius: 5px;
}
.g-button.large {
  padding: 8px 50px;
}
.g-button.roundBorder {
  border-radius: 36px;
}
.g-button.fullWidth {
  width: 100%;
}
.g-button.primary {
  background-color: #104a64;
  border-color: #104a64;
  box-shadow: 5px 5px 10px -3px rgba(0, 0, 0, 0.81);
  color: white;
  height: 38px;
  width: auto;
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.g-button.submit {
  background-color: #104a64;
  border-color: #104a64;
  box-shadow: 8px 12px 30px rgba(46, 81, 65, 0.48);
  color: white;
}
.g-button.submit:hover {
  background-color: #e9af51;
  border-color: #e9af51;
  color: white;
}
.g-button.secondary {
  background-color: #e9af51;
  border-color: #e9af51;
  color: white;
}
.g-button.primary-outline {
  background-color: transparent;
  border-color: #104a64;
  border-style: solid;
  border-width: 1px;
  color: #104a64;
}
.g-button.primary-outline .loading-spinner ::ng-deep circle {
  stroke: #104a64;
}
.g-button.secondary-outline {
  background-color: transparent;
  border-color: #e9af51;
  border-style: solid;
  border-width: 1px;
  color: #e9af51;
  height: 39px;
  width: auto;
  padding-left: 16px;
  padding-right: 16px;
}
.g-button.secondary-outline .loading-spinner ::ng-deep circle {
  stroke: #e9af51;
}
.g-button.simple-squared-outline {
  background-color: transparent;
  border-radius: 5px !important;
  border: 1px solid gray !important;
  height: 39px;
  padding-left: 16px;
  padding-right: 16px;
  width: 107px;
}
.g-button .text-content {
  font-size: 0.9rem;
  letter-spacing: normal;
}
.g-button .loading-spinner {
  margin: auto;
}
.g-button .loading-spinner ::ng-deep circle {
  stroke: rgba(255, 255, 255, 0.6117647059);
}
.g-button ::ng-deep mat-icon.marginRight {
  margin-right: 15px;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}

::ng-deep .tooltip .mdc-tooltip__surface {
  background: #ecac54 !important;
  font-size: 0.9rem !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/shared/components/g-button/g-button.component.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,kBAAA;AADF;AAGE;EACE,iBAAA;AADJ;AAIE;EACE,mBAAA;AAFJ;AAKE;EACE,WAAA;AAHJ;AAME;EACE,yBCjBY;EDkBZ,qBClBY;EDoBZ,iDAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;EACA,8BAAA;AALJ;AASE;EACE,yBC9BY;ED+BZ,qBC/BY;EDgCZ,gDAAA;EACA,YAAA;AAPJ;AASI;EACE,yBC/BY;EDgCZ,qBChCY;EDiCZ,YAAA;AAPN;AAWE;EACE,yBCtCc;EDuCd,qBCvCc;EDwCd,YAAA;AATJ;AAYE;EACE,6BAAA;EACA,qBClDY;EDmDZ,mBAAA;EACA,iBAAA;EACA,cCrDY;AD2ChB;AAeQ;EACE,eC3DM;AD8ChB;AAmBE;EACE,6BAAA;EACA,qBC9Dc;ED+Dd,mBAAA;EACA,iBAAA;EACA,cCjEc;EDkEd,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAjBJ;AAqBQ;EACE,eC1EQ;ADuDlB;AAyBE;EACE,6BAAA;EACA,6BAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAvBJ;AA0BE;EACE,iBAAA;EACA,sBAAA;AAxBJ;AA2BE;EACE,YAAA;AAzBJ;AA4BM;EACE,yCAAA;AA1BR;AAmCM;EACE,kBAAA;AAjCR;;AAsCA;EACE,kCAAA;AAnCF;;AAqCA;EACE,8BAAA;EACA,4BAAA;EACA,wBAAA;EACA,kCAAA;EACA,8BAAA;AAlCF","sourcesContent":["@import \"/src/styles/_variables.scss\";\r\n\r\n.g-button {\r\n  height: 100%;\r\n  border-radius: 5px;\r\n\r\n  &.large {\r\n    padding: 8px 50px;\r\n  }\r\n\r\n  &.roundBorder {\r\n    border-radius: 36px;\r\n  }\r\n\r\n  &.fullWidth {\r\n    width: 100%;\r\n  }\r\n\r\n  &.primary {\r\n    background-color: $primary-color;\r\n    border-color: $primary-color;\r\n    //box-shadow: 8px 12px 30px rgba(46, 81, 65, 0.48);\r\n    box-shadow: 5px 5px 10px -3px rgba(0, 0, 0, 0.81);\r\n    color: white;\r\n    height: 38px;\r\n    width: auto;\r\n    padding-left: 15px !important;\r\n    padding-right: 15px !important;\r\n  }\r\n\r\n\r\n  &.submit {\r\n    background-color: $primary-color;\r\n    border-color: $primary-color;\r\n    box-shadow: 8px 12px 30px rgba(46, 81, 65, 0.48);\r\n    color: white;\r\n\r\n    &:hover {\r\n      background-color: $secondary-color;\r\n      border-color: $secondary-color;\r\n      color: white;\r\n    }\r\n  }\r\n\r\n  &.secondary {\r\n    background-color: $secondary-color;\r\n    border-color: $secondary-color;\r\n    color: white;\r\n  }\r\n\r\n  &.primary-outline {\r\n    background-color: transparent;\r\n    border-color: $primary-color;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    color: $primary-color;\r\n    \r\n\r\n    .loading-spinner {\r\n      ::ng-deep {\r\n        circle {\r\n          stroke: $primary-color;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.secondary-outline {\r\n    background-color: transparent;\r\n    border-color: $secondary-color;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    color: $secondary-color;\r\n    height: 39px;\r\n    width: auto;\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n\r\n    .loading-spinner {\r\n      ::ng-deep {\r\n        circle {\r\n          stroke: $secondary-color;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.simple-squared-outline {\r\n    background-color: transparent;\r\n    border-radius: 5px !important;\r\n    border: 1px solid gray !important;\r\n    height: 39px;\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n    width: 107px;\r\n  }\r\n\r\n  .text-content {\r\n    font-size: 0.9rem;\r\n    letter-spacing: normal;\r\n  }\r\n\r\n  .loading-spinner {\r\n    margin: auto;\r\n\r\n    ::ng-deep {\r\n      circle {\r\n        stroke: #ffffff9c;\r\n      }\r\n    }\r\n  }\r\n\r\n  ::ng-deep {\r\n    mat-icon {\r\n      //width: auto;\r\n\r\n      &.marginRight {\r\n        margin-right: 15px;\r\n      }\r\n    }\r\n  }\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}\r\n::ng-deep .tooltip .mdc-tooltip__surface {\r\n  background: #ecac54 !important;\r\n  font-size: 0.9rem !important;\r\n  display: flex !important;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n\r\n}","// Général\r\n$content-background-color: white;\r\n$primary-color: #104a64;\r\n$success-color: #badbcc;\r\n$success-text-color: #0f5132;\r\n$error-color: #f5c2c7;\r\n$error-text-color: #842029;\r\n$secondary-color: #e9af51;\r\n$secondary-color-light: #e9af51a1;\r\n$danger-color: rgb(255, 79, 79);\r\n$page-title-size: 2.3rem;\r\n$common-size: 1.05rem;\r\n$background-light: #104a64;\r\n\r\n// Header\r\n$width-logo: 145px;\r\n$filter-logo: brightness(0) invert(1);\r\n$header-height: 70px;\r\n$header-color-bottom-border: #cbd3db;\r\n\r\n// Left menu\r\n$left-menu-text-color: white;\r\n\r\n// GED\r\n$ged-background-hover-color: #e9af5128;\r\n$ged-folder-color: $primary-color;\r\n$ged-file-color: $primary-color;\r\n$ged-folder-color-hover: #0056b3;\r\n$ged-file-color-hover: #0056b3;\r\n\r\n// Data Tree\r\n$data-tree-left-menu-width: 300px;\r\n$data-tree-article-title-font-size: 2.8rem;\r\n$data-tree-highlight-color: $secondary-color;\r\n\r\n// See rooms\r\n$see-rooms-title-size: 1.7rem;\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
